"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var lodash_1 = require("lodash");
var react_toastify_1 = require("react-toastify");
var react_google_recaptcha_v3_1 = require("react-google-recaptcha-v3");
var html_react_parser_1 = __importDefault(require("html-react-parser"));
var formik_1 = require("formik");
var material_1 = require("@mui/material");
var Send_1 = __importDefault(require("@mui/icons-material/Send"));
/* eslint-disable no-restricted-syntax */
var trans_1 = __importDefault(require("@/plugins/trans"));
var useIsSmallScreen_1 = __importDefault(require("../../hooks/useIsSmallScreen"));
var Button_1 = __importDefault(require("../../Button"));
var GoogleIcon_1 = __importDefault(require("../../icons/GoogleIcon"));
var FormikTextField_1 = __importDefault(require("../../components/FormikTextField"));
var ApplyDialogStyles_1 = require("./ApplyDialogStyles");
var FormikCheckbox_1 = __importDefault(require("../../components/FormikCheckbox"));
var ConfirmAccountBlockMobile_1 = __importDefault(require("./ConfirmAccountBlockMobile"));
var BookmarkedContext_1 = __importDefault(require("../../context/BookmarkedContext"));
var FormikPhoneField_1 = __importDefault(require("../../components/FormikPhoneField"));
var defaultRegisterData = {
    first_name: '',
    surname: '',
    email: '',
    password: '',
    country: '',
    phoneNumber: '',
    accept_terms: false,
};
var RegisterForm = function (_a) {
    var activeStep = _a.activeStep;
    var bookmarks = (0, react_1.useContext)(BookmarkedContext_1.default).bookmarks;
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    var isVisible = activeStep === 1 ? 'block' : 'none';
    var executeRecaptcha = (0, react_google_recaptcha_v3_1.useGoogleReCaptcha)().executeRecaptcha;
    var _b = (0, react_1.useState)(), token = _b[0], setToken = _b[1];
    var handleReCaptchaVerify = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!executeRecaptcha) {
                        return [2 /*return*/];
                    }
                    _a = setToken;
                    return [4 /*yield*/, executeRecaptcha()];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    // You can use useEffect to trigger the verification as soon as the component being loaded
    (0, react_1.useEffect)(function () {
        handleReCaptchaVerify();
    }, [handleReCaptchaVerify]);
    var validate = function (values) {
        var errors = {};
        return axios_1.default
            .post('/validate', __assign(__assign({}, values), { validateRequest: 'RegisterRequest' }))
            .then(function () {
            return {};
        })
            .catch(function (_a) {
            var _b;
            var response = _a.response;
            var responseErrors = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.errors;
            if (responseErrors) {
                // eslint-disable-next-line guard-for-in
                for (var field in responseErrors) {
                    errors[field] = responseErrors[field].join(', ');
                }
            }
            return errors;
        });
    };
    var debouncedValidate = (0, lodash_1.debounce)(validate, 300, { leading: true });
    var handleRegister = function (values, _a) {
        var setSubmitting = _a.setSubmitting;
        axios_1.default
            .post('/register', __assign(__assign({}, values), { bookmarks: JSON.stringify(Array.from(bookmarks !== null && bookmarks !== void 0 ? bookmarks : [])), 'g-recaptcha-response': token }))
            .then(function (_a) {
            var data = _a.data;
            react_toastify_1.toast.success(trans_1.default.get('alerts.frontend.register.success'), {
                position: 'bottom-right',
                autoClose: 5000,
                hideProgressBar: true,
                pauseOnHover: false,
            });
            window.location.href = data;
        })
            .finally(function () {
            setSubmitting(false);
        });
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ fontWeight: "bold", color: "black", sx: __assign({ display: isVisible }, ApplyDialogStyles_1.formBlockStyles.paddingSpace) }, { children: trans_1.default.get('labels.frontend.auth.almost_there') })), isSmallScreen && activeStep === 1 && (0, jsx_runtime_1.jsx)(ConfirmAccountBlockMobile_1.default, {}), (0, jsx_runtime_1.jsx)(formik_1.Formik, __assign({ initialValues: defaultRegisterData, validate: debouncedValidate, onSubmit: handleRegister }, { children: function (_a) {
                    var isSubmitting = _a.isSubmitting, setFieldValue = _a.setFieldValue;
                    return ((0, jsx_runtime_1.jsxs)(formik_1.Form, { children: [(0, jsx_runtime_1.jsx)(material_1.DialogContent, __assign({ sx: __assign({ display: isVisible }, ApplyDialogStyles_1.formBlockStyles.paddingSpace) }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", flexDirection: "column" }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, __assign({ sx: ApplyDialogStyles_1.registerBlockStyles.label }, { children: trans_1.default.get('columns.profile.first_name') })), (0, jsx_runtime_1.jsx)(FormikTextField_1.default, { sx: ApplyDialogStyles_1.registerBlockStyles.textField, name: "first_name" }), (0, jsx_runtime_1.jsx)(material_1.InputLabel, __assign({ sx: ApplyDialogStyles_1.registerBlockStyles.label }, { children: trans_1.default.get('columns.profile.surname') })), (0, jsx_runtime_1.jsx)(FormikTextField_1.default, { sx: ApplyDialogStyles_1.registerBlockStyles.textField, name: "surname" }), (0, jsx_runtime_1.jsx)(material_1.InputLabel, __assign({ sx: ApplyDialogStyles_1.registerBlockStyles.label }, { children: trans_1.default.get('columns.profile.country') })), (0, jsx_runtime_1.jsx)(FormikPhoneField_1.default, { sx: ApplyDialogStyles_1.registerBlockStyles.textField, setFieldValue: setFieldValue, name: "country" }), (0, jsx_runtime_1.jsx)(material_1.InputLabel, __assign({ sx: ApplyDialogStyles_1.registerBlockStyles.label }, { children: trans_1.default.get('columns.profile.tel') })), (0, jsx_runtime_1.jsx)(FormikTextField_1.default, { sx: ApplyDialogStyles_1.registerBlockStyles.textField, name: "phoneNumber" }), (0, jsx_runtime_1.jsx)(material_1.InputLabel, __assign({ sx: ApplyDialogStyles_1.registerBlockStyles.label }, { children: trans_1.default.get('columns.profile.email') })), (0, jsx_runtime_1.jsx)(FormikTextField_1.default, { sx: ApplyDialogStyles_1.registerBlockStyles.textField, name: "email", type: "email" }), (0, jsx_runtime_1.jsx)(material_1.InputLabel, __assign({ sx: ApplyDialogStyles_1.registerBlockStyles.label }, { children: trans_1.default.get('validation.attributes.frontend.password') })), (0, jsx_runtime_1.jsx)(FormikTextField_1.default, { sx: ApplyDialogStyles_1.registerBlockStyles.textField, name: "password", type: "password" }), (0, jsx_runtime_1.jsx)(FormikCheckbox_1.default, { name: "accept_terms", label: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, html_react_parser_1.default)(trans_1.default.get('validation.attributes.frontend.accept_terms')) }) })] })) })), (0, jsx_runtime_1.jsx)(material_1.DialogActions, __assign({ sx: __assign(__assign(__assign({}, ApplyDialogStyles_1.formBlockStyles.paddingSpace), (isSmallScreen ? ApplyDialogStyles_1.registerBlockStyles.buttonsMobile : ApplyDialogStyles_1.registerBlockStyles.buttons)), { display: activeStep === 1 ? 'flex' : 'none' }) }, { children: isSubmitting ? ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, {})) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({ disabled: isSubmitting, type: "submit", id: "send", endIcon: (0, jsx_runtime_1.jsx)(Send_1.default, {}) }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ style: { marginRight: '.75rem' } }, { children: trans_1.default.get('buttons.frontend.application.send') })) })), trans_1.default.get('labels.general.or'), (0, jsx_runtime_1.jsxs)(material_1.Link, __assign({ href: "/login/google", sx: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '2px',
                                                paddingRight: '12px',
                                                backgroundColor: '#619BF0',
                                                textDecoration: 'none',
                                                color: 'white',
                                            } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: { backgroundColor: 'white', padding: '10px 12px', mr: '12px' } }, { children: (0, jsx_runtime_1.jsx)(GoogleIcon_1.default, {}) })), trans_1.default.get('buttons.general.sign_in_google')] }))] })) }))] }));
                } }))] }));
};
exports.default = RegisterForm;
